import axios from '../services/axios';
import roles from '../configs/roles';
import permissionsList from '../configs/permissions';

export const checkPermissions = (permission, permissionsList) => {
  if (Array.isArray(permission)) return permission.some((p) => permissionsList.includes(p));
  return permissionsList.includes(permission);
};

// eslint-disable-next-line import/prefer-default-export
export const $can = (permission, permissions, adminMode) => {
  const listOfPermissions = permissions || JSON.parse(localStorage.getItem('permissions'));

  if (!permission.permission && permission.adminMode && permission.initiativeMode) {
    return true;
  }
  if (!permission.permission && permission.adminMode) {
    return adminMode;
  }

  if (!permission.permission && permission.initiativeMode) {
    return !adminMode;
  }

  return adminMode
    ? checkPermissions(permission.permission, listOfPermissions) && permission.adminMode
    : checkPermissions(permission.permission, listOfPermissions) && permission.initiativeMode;
};

export const isSuperAdmin = (role) => role === roles.superAdmin.name;
export const isOrgAdmin = (role) => role === roles.orgAdmin.name;
export const isInitiativeAdmin = (role) => role === roles.initiativeAdmin.name;
export const isInitiativeOrganizer = (role) => role === roles.initiativeOrganizer.name;
export const isInitiativeManager = (role) => role === roles.initiativeManager.name;
export const isInitiativeAssignee = (role) => role === roles.initiativeAssignee.name;
export const isDataAssignee = (role) => role === roles.dataAssignee.name;
export const isAuxiliaryTaskSpecialist = (role) => role === roles.auxiliaryTaskSpecialist.name;
export const isPetitionImageViewer = (role) => role === roles.petitionImageViewer.name;
export const isPetitionUploader = (role) => role === roles.petitionUploader.name;
export const isReportViewer = (role) => role === roles.reportViewer.name;
export const isCanvassingOrganizationUser = (role) =>
  role === roles.canvassingOrganizationUser.name;

export const setPermissions = (role, initiativeRole, orgRole, permissions) => {
  let permissionsArr = permissions;
  if (
    !isInitiativeAdmin(initiativeRole) &&
    !isSuperAdmin(role) &&
    !isInitiativeAdmin(orgRole) &&
    !isDataAssignee(role) &&
    !isDataAssignee(initiativeRole) &&
    !isDataAssignee(orgRole)
  ) {
    permissionsArr = [...permissionsArr, permissionsList.view_manual_in_sidebar];
  }
  return permissionsArr;
};

/**
 * Logout user client-side and/or server-side
 *
 * @param {boolean} clientSideOnly - Whether to logout client-side only
 * @param {string} message - The message to display to the user after logout
 * @returns {void}
 */
export const logoutUser = async (clientSideOnly = false, message = null) => {
  if (!clientSideOnly) {
    await axios.post('/api/logout');
  }

  localStorage.clear();
  sessionStorage.clear();
  if (message) {
    localStorage.setItem('logout_error', message);
  }
  window.location.replace('/manage-petitions/auth/sign-in');
};
